import React, { Component } from 'react'
import './css/App.scss'

import Menu from './components/menu'
import Imprint from './components/imprint'

import IdeaPage from './pages/ideapage'
import GroupPage from './pages/grouppage'
import VideosPage from './pages/videospage'
import OnePager from './pages/onepager'

import { BrowserRouter as Router, Route } from 'react-router-dom'

export default class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedLanguage: 'de'
    }
  }

  selectLanguage(language) {
    this.setState({ selectedLanguage: language })
  }

  render() {
    return (
      <Router>
        <div className="App">
          <Route path="/" render={route => <Menu {...route} />} />
          <Route
            exact
            path="/"
            render={route => (
              <OnePager
                selectedLanguage={this.state.selectedLanguage}
                selectLanguage={this.selectLanguage.bind(this)}
                {...route}
              />
            )}
          />
          <Route exact path="/videos" render={route => <VideosPage />} />
          <Route exact path="/unsere_gruppe" render={route => <GroupPage />} />
          <Route
            exact
            path="/die_idee"
            render={route => (
              <IdeaPage
                selectedLanguage={this.state.selectedLanguage}
                selectLanguage={this.selectLanguage.bind(this)}
                {...route}
              />
            )}
          />
          <Imprint />
        </div>
      </Router>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/